import React from 'react'
import { useAppSelector } from '../../store/hooks/hooks';
import WaterContentChart from './WaterContentChart';


const ChartSection: React.FC = () => {
	const calculator = useAppSelector(state => state.waterContentCalculator);
	const reservoir = calculator?.chartsData?.reservoir?.map(d => ({ x: d.p, y: d.w }));
	const wellhead = calculator?.chartsData?.wellhead?.map(d => ({ x: d.p, y: d.w }));
	return <div className="water-content__charts round-corner-container">
		<WaterContentChart data={reservoir} isLoading={false}></WaterContentChart>
		<WaterContentChart data={wellhead} isLoading={false}></WaterContentChart>
	</div>
}

export default ChartSection